module.exports = __webpack_public_path__ + "static/media/dashboard-checkin.cc3bd138.svg";